module.exports = __webpack_public_path__ + "static/media/untitled-interior-composition.4998a7ed.jpg";